import React, { useState } from 'react';

const Step1Personal = ({ data, onChange, onNext }) => {
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    onChange({ [field]: value });
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const e = {};
    if (!data.personal_email || !data.personal_email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      e.personal_email = 'Enter a valid email address';
    if (!data.full_name || data.full_name.trim().length < 2)
      e.full_name = 'Full name is required';
    if (!data.phone || !data.phone.match(/^[6-9]\d{9}$/))
      e.phone = 'Enter a valid 10-digit mobile number';
    if (!data.date_of_birth) {
      e.date_of_birth = 'Date of birth is required';
    } else {
      const age = new Date().getFullYear() - new Date(data.date_of_birth).getFullYear();
      if (age < 18 || age > 70) e.date_of_birth = 'Age must be between 18 and 70';
    }
    if (!data.gender) e.gender = 'Select your gender';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleNext = () => { if (validate()) onNext(); };

  return (
    <div className="ob-step">
      <div className="ob-step__header">
        <h2>Personal Details</h2>
        <p>Enter your basic personal information to get started.</p>
      </div>

      <div className="ob-grid ob-grid--2">
        <div className="ob-field ob-field--full">
          <label>Company Email <span className="ob-badge ob-badge--info">Auto-filled</span></label>
          <input type="email" value={data.company_email} disabled className="ob-input ob-input--disabled" />
        </div>

        <div className="ob-field">
          <label>Personal Email <span className="ob-required">*</span></label>
          <input
            type="email"
            className={`ob-input ${errors.personal_email ? 'ob-input--error' : ''}`}
            placeholder="you@example.com"
            value={data.personal_email}
            onChange={(e) => handleChange('personal_email', e.target.value)}
          />
          {errors.personal_email && <span className="ob-error">{errors.personal_email}</span>}
        </div>

        <div className="ob-field">
          <label>Full Name <span className="ob-required">*</span></label>
          <input
            type="text"
            className={`ob-input ${errors.full_name ? 'ob-input--error' : ''}`}
            placeholder="Enter your full name"
            value={data.full_name}
            onChange={(e) => handleChange('full_name', e.target.value)}
          />
          {errors.full_name && <span className="ob-error">{errors.full_name}</span>}
        </div>

        <div className="ob-field">
          <label>Phone Number <span className="ob-required">*</span></label>
          <div className="ob-input-group">
            <span className="ob-input-group__prefix">+91</span>
            <input
              type="tel"
              className={`ob-input ${errors.phone ? 'ob-input--error' : ''}`}
              placeholder="9876543210"
              maxLength="10"
              value={data.phone}
              onChange={(e) => handleChange('phone', e.target.value.replace(/\D/g, ''))}
            />
          </div>
          {errors.phone && <span className="ob-error">{errors.phone}</span>}
        </div>

        <div className="ob-field">
          <label>Date of Birth <span className="ob-required">*</span></label>
          <input
            type="date"
            className={`ob-input ${errors.date_of_birth ? 'ob-input--error' : ''}`}
            value={data.date_of_birth}
            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0]}
            onChange={(e) => handleChange('date_of_birth', e.target.value)}
          />
          {errors.date_of_birth && <span className="ob-error">{errors.date_of_birth}</span>}
        </div>

        <div className="ob-field">
          <label>Gender <span className="ob-required">*</span></label>
          <select
            className={`ob-input ob-select ${errors.gender ? 'ob-input--error' : ''}`}
            value={data.gender}
            onChange={(e) => handleChange('gender', e.target.value)}
          >
            <option value="">Select gender</option>
            <option value="MALE">Male</option>
            <option value="FEMALE">Female</option>
            <option value="OTHER">Other</option>
          </select>
          {errors.gender && <span className="ob-error">{errors.gender}</span>}
        </div>

        <div className="ob-field">
          <label>Blood Group <span className="ob-badge ob-badge--muted">Optional</span></label>
          <select
            className="ob-input ob-select"
            value={data.blood_group}
            onChange={(e) => handleChange('blood_group', e.target.value)}
          >
            <option value="">Select blood group</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="O+">O+</option>
            <option value="O-">O-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
          </select>
        </div>
      </div>

      <div className="ob-actions">
        <div></div>
        <button className="ob-btn ob-btn--primary" onClick={handleNext}>
          Continue
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3 7h8M8 4l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Step1Personal;
